import { HttpErrorResponse } from '@angular/common/http';
import { BackendError } from './rest-client-base.models';

/**
 * Extract localized error messages from backend error response.
 * Works with both HttpErrorResponse and raw error body.
 *
 * Backend format: [{ message: { i18n: { pl: "...", en: "...", de: "..." } } }]
 *
 * @param error - HttpErrorResponse or raw error body
 * @param langCode - 2-letter language code (e.g., 'pl', 'en', 'de')
 * @returns Array of localized error messages
 */
export function extractBackendErrorMessages(error: unknown, langCode: string): string[] {
  const body = error instanceof HttpErrorResponse ? error.error : error;
  const errors: BackendError[] = Array.isArray(body) ? body : (body ? [body] : []);

  return errors
    .map((e) => {
      const i18n = e?.message?.i18n;
      if (!i18n) return null;
      return (i18n as Record<string, string>)[langCode] ?? i18n['en'] ?? Object.values(i18n)[0] ?? null;
    })
    .filter((msg): msg is string => msg !== null);
}
